import React from 'react';
import { css } from '@linaria/atomic';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Button } from '../../button/button.component';
import { ColorPicker } from '../../color-picker/color-picker';
import { PopoverDialog } from '../../popover/dialog/popover-dialog.component';
import { usePopoverDialog } from '../../popover/dialog/use-popover-dialog';
import { ActionDropdownChip } from '../atoms/action-dropdown-chip';

const highlightColorActionPopoverDialogStyle1 = css`
  border-radius: ${theme.borderRadius.medium};
`;

const highlightColorActionButtonStyle2 = css`
  width: 100%;
  margin-bottom: ${theme.spacing(1)};
`;

type HighlightColorActionProps = Pick<
  React.ComponentProps<typeof ColorPicker>,
  'color' | 'onChange' | 'palette' | 'imageSrc' | 'shouldApply'
> &
  Pick<React.ComponentProps<typeof ActionDropdownChip>, 'showBoxShadow' | 'compact' | 'className'> & {
    onReset?: () => void;
  };

export const HighlightColorAction = ({
  color = undefined,
  showBoxShadow = true,
  compact = true,
  onReset,
  className: actionStyle,
  ...rest
}: HighlightColorActionProps) => {
  const { getTriggerProps, getDialogProps, isOpen, close } = usePopoverDialog<HTMLButtonElement>({
    placement: 'bottom-start',
  });

  return (
    <>
      <ActionDropdownChip
        compact={compact}
        {...getTriggerProps()}
        showBoxShadow={showBoxShadow}
        isActive={isOpen || !!color}
        isOpen={isOpen}
        className={actionStyle}
      >
        <Icon name='highlight-small' />
      </ActionDropdownChip>
      <PopoverDialog {...getDialogProps()} className={highlightColorActionPopoverDialogStyle1} returnFocus={false}>
        <Button disabled={!color} onClick={onReset} variant='secondary' className={highlightColorActionButtonStyle2}>
          Clear Highlight
        </Button>
        <ColorPicker syncColor={color} onClick={close} {...rest} />
      </PopoverDialog>
    </>
  );
};
